module.exports = {
  IdentifyDevice: "IdentifyDevice",
  CloseSocket: "CloseSocket",
  Heartbeat: "Heartbeat",
  SendAction: "SendAction",
  RequestConnectionInfo: "RequestConnectionInfo",
  ServerResponse: "ServerResponse",
  Kickout: "Kickout",
  Join: "Join",
  Leave: "Leave",
  RequestConnectionDetails: "RequestConnectionDetails",
  RequestConfig: "RequestConfig",
  UpdateConfig: "UpdateConfig",
  RequestLobbies: "RequestLobbies",

  ConnectionStatus: "ConnectionStatus",
  Action: "Action",
  Request: "ClientRequest",
  Response: "onResponse",
  IISAck: "onIISAck",
  ConnectionInfo: "onConnectionInfo",
  NotifyLeave: "NotifyLeave",
  NotifyJoin: "NotifyJoin",
  NotifyConnectionDetails: "NotifyConnectionDetails",
  NotifyConfig: "NotifyConfig",
  NotifyLobbies: "NotifyLobbies",
  ResponseGroupInfo: "ResponseGroupInfo",
  OnTest: "OnTest",

  AtgGames: "AtgGames",
  JoinAtgGames: "JoinAtgGames",
  LeaveAtgGames: "LeaveAtgGames",
  NotifyAtgGames: "NotifyAtgGames",
  NotifyJoinAtgGames: "NotifyJoinAtgGames",
  NotifyLeaveAtgGames: "NotifyLeaveAtgGames",

  RsgGames: "RsgGames",
  JoinRsgGames: "JoinRsgGames",
  LeaveRsgGames: "LeaveRsgGames",
  NotifyRsgGames: "NotifyRsgGames",
  NotifyJoinRsgGames: "NotifyJoinRsgGames",
  NotifyLeaveRsgGames: "NotifyLeaveRsgGames",

  RequestTopUpToGame: "RequestTopUpToGame",
};
